/* ============================================================================
   Planos — listagem em cartões.
   ============================================================================ */
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../services/api';
import AdminLayout from '../components/AdminLayout';
import PageHeader from '../components/PageHeader';
import { Loading, EmptyState } from '../components/ui';
import { confirm } from '../components/Modal';
import { toast } from '../components/Toast';
import { IconPlus, IconPlans, IconEdit, IconTrash, IconCheck, IconX } from '../components/icons';
import './Plans.css';

export default function Plans() {
  const navigate = useNavigate();
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => { load(); }, []);

  const load = async () => {
    try {
      const res = await api.get('/admin/plans', true);
      if (res.success) setPlans(res.data || []);
    } catch { toast.error('Erro ao carregar planos.'); }
    finally { setLoading(false); }
  };

  const handleDelete = async (plan) => {
    const ok = await confirm({ title: 'Deletar plano', message: `Tem certeza que deseja deletar o plano "${plan.name}"?`, confirmLabel: 'Deletar', danger: true });
    if (!ok) return;
    try {
      await api.delete(`/admin/plans/${plan.id}`, true);
      setPlans((prev) => prev.filter((p) => p.id !== plan.id));
      toast.success('Plano deletado.');
    } catch (err) { toast.error(err.message || 'Erro ao deletar plano.'); }
  };

  const money = (v) => `R$ ${(v || 0).toFixed(2)}`;

  return (
    <AdminLayout>
      <PageHeader
        title="Planos"
        subtitle="Crie, edite e organize os planos da plataforma"
        action={<button className="mg-btn mg-btn-primary" onClick={() => navigate('/treinamentos/manager/plans/new')}><IconPlus /> Novo plano</button>}
      />

      {loading ? <Loading /> : plans.length === 0 ? (
        <EmptyState icon={<IconPlans size={26} />} title="Nenhum plano cadastrado"
          action={<button className="mg-btn mg-btn-primary" onClick={() => navigate('/treinamentos/manager/plans/new')}><IconPlus /> Criar primeiro plano</button>}>
          Crie planos para liberar acesso aos cursos pagos.
        </EmptyState>
      ) : (
        <div className="plans-grid">
          {plans.map((plan) => {
            const color = plan.color || '#d17d34';
            return (
              <div key={plan.id} className={`plans-card${plan.isRecommended ? ' is-rec' : ''}`} style={{ '--plan-color': color }}>
                {plan.isRecommended && <span className="plans-rec-badge">Recomendado</span>}
                <div className="plans-card-head">
                  <h3>{plan.name}</h3>
                  <span className="plans-dot" style={{ background: color }} />
                </div>
                <div className="plans-prices">
                  <div><span className="plans-price-lbl">Mensal</span><span className="plans-price">{money(plan.monthlyPrice)}</span></div>
                  <div><span className="plans-price-lbl">Trimestral</span><span className="plans-price">{money(plan.quarterlyPrice)}</span></div>
                </div>
                {(plan.features || []).length > 0 && (
                  <ul className="plans-features">
                    {plan.features.map((f, i) => {
                      const text = typeof f === 'string' ? f : f.text;
                      const included = typeof f === 'string' ? true : f.included;
                      return (
                        <li key={i} className={included ? '' : 'is-excluded'}>
                          <span className="plans-feat-icon">{included ? <IconCheck size={13} /> : <IconX size={13} />}</span>
                          {text}
                        </li>
                      );
                    })}
                  </ul>
                )}
                <div className="plans-card-actions">
                  <button className="mg-act mg-act-amber" onClick={() => navigate(`/treinamentos/manager/plans/${plan.id}/edit`)}><IconEdit /> Editar</button>
                  <button className="mg-act mg-act-red" onClick={() => handleDelete(plan)}><IconTrash /> Deletar</button>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </AdminLayout>
  );
}
